import { render } from "./budgetrevenues-model.vue?vue&type=template&id=5a013739"
import script from "./budgetrevenues-model.vue?vue&type=script&lang=js"
export * from "./budgetrevenues-model.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__